export default __webpack_public_path__ + "static/media/blank-profile.f2ae27a5.png";